import {
  CreatePartnerWorkerClaPayload,
  CreatePartnerWorkerClaScalePayload,
  CreatePartnerWorkerClaStepPayload,
} from 'partner/shared/services/partner-worker-service.types';
import { AddClaFormValues } from './add-cla-dialog.types';

export const mapFormDataToPayload = (values: AddClaFormValues): CreatePartnerWorkerClaPayload => ({
  name: values.name,
  scales: values.scales.map(
    (scale): CreatePartnerWorkerClaScalePayload => ({
      scale: scale.scale,
      steps: scale.steps.map(
        (step): CreatePartnerWorkerClaStepPayload => ({
          step: step.step,
          startDate: step.startDate,
          endDate: step.endDate || null,
        })
      ),
    })
  ),
});
